import { AENDERUNGEN, versionText } from '../version';
import { Card } from '../components/ui';

const datum = (iso: string) => {
  const [jahr, monat, tag] = iso.split('-');
  return `${tag}.${monat}.${jahr}`;
};

export function NeuigkeitenPage() {
  return (
    <>
      <p className="small" style={{ marginTop: 0 }}>{versionText()}</p>
      {AENDERUNGEN.map((a) => (
        <Card key={a.nummer}>
          <h3 style={{ marginTop: 0 }}>
            Version {a.nummer} <span className="small" style={{ fontWeight: 400 }}>vom {datum(a.datum)}</span>
          </h3>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {a.punkte.map((p, i) => (
              <li key={i} style={{ marginBottom: 4 }}>{p}</li>
            ))}
          </ul>
        </Card>
      ))}
    </>
  );
}
